import React from "react";

export const IntegrationsIcon: React.FC<{
  isActive?: boolean;
}> = ({
  isActive = false,
}) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.64939 1C5.20348 1.00661 3.3974 1.09068 2.24499 2.24404C1 3.48903 1 5.49253 1 9.49953C1 13.5065 1 15.51 2.24499 16.755C3.48997 18 5.49253 18 9.49953 18C13.5065 18 15.51 18 16.755 16.755C17.9084 15.6026 17.9924 13.7965 17.9991 10.3506M17.5098 1.48647L12.2691 6.7139M13.2364 1.07273C13.9004 1.06329 17.0441 1.01984 17.5107 1.48647C17.9773 1.95405 17.9339 5.10052 17.9244 5.76552"
        fill="none"
        stroke={isActive ? "var(--active-color)" : "#83829D"}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
